import { render, staticRenderFns } from "./CadastroProfissionalPublico.vue?vue&type=template&id=01546a17&scoped=true"
import script from "./CadastroProfissionalPublico.vue?vue&type=script&lang=js"
export * from "./CadastroProfissionalPublico.vue?vue&type=script&lang=js"
import style0 from "./CadastroProfissionalPublico.vue?vue&type=style&index=0&id=01546a17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01546a17",
  null
  
)

export default component.exports